import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EdlTooltipIcon } from '../enum/edl-tooltip-icon.enum';
import { SORT_BY_TOOLTIP_CONFIG } from './constants/paetep-sort-by-tooltip-config.constant';

/**
 * A sortable table column header. It only reports which column the user chose; whatever page it
 * sits on decides what to do about that.
 *
 * This is a near copy of edl-common's `sort-by`, differing only in functionality. They should
 * be combined at some point.
 */
@Component({
    selector: 'paetep-sort-by',
    templateUrl: './paetep-sort-by.component.html',
    styleUrls: ['./paetep-sort-by.component.scss']
})
export class PaetepSortByComponent {
    @Input() label: string = '';
    @Input() field: string = '';
    /**
     * An explanation of what the column counts, shown when the header is hovered or tabbed to.
     * The header itself carries it, so a keyboard user reaches the explanation by the same route
     * they reach the sorting, and the icon beside the label stays decoration.
     */
    @Input() tooltip: string = '';
    /** The icon marking a column as having an explanation. */
    @Input() tooltipIcon: EdlTooltipIcon = EdlTooltipIcon.INFO;

    @Output() onSortBy: EventEmitter<string> = new EventEmitter<string>();

    /** Leaves Enter and Space to sort the column rather than opening the explanation. */
    public readonly tooltipConfig = SORT_BY_TOOLTIP_CONFIG;

    constructor() { }

    sortBy = () => {
        this.onSortBy.emit(this.field);
    }
}
